export default "__VITE_PUBLIC_ASSET__f64ca32d__"